export default __webpack_public_path__ + "static/media/temp stay E4 - Professional Activity Visa.72b45840.jpg";